import { useState } from 'react';
import Image from 'next/image';
import {
  SvgCheckbox,
  SvgEmptyCheckbox,
  SvgCheck,
  SvgCrossedCheckbox
} from '../Icons';
import Price from '@/components/price/Price';

export function SliderCard({ card, discountType, addSelectedProducts }) {
  const [selected, setSelected] = useState(false);
  const handleClick = (e) => {
    e.preventDefault();
    addSelectedProducts(card.product, card.variant, selected);
    setSelected(!selected);
  };

  const productOutOfStock =
    card?.product?.outOfStock?.value == 'true' ||
    card?.variant?.outOfStock?.value == 'true'
      ? true
      : false;

  const discountAmount =
    discountType == 'Percentage Amount'
      ? Math.floor(
          100 -
            (card?.variant?.price?.amount /
              card?.variant?.compareAtPrice?.amount) *
              100
        ) + '% OFF'
      : '$' +
        Math.floor(
          card?.variant?.compareAtPrice?.amount - card?.variant?.price?.amount
        ) +
        ' OFF';
  return (
    <button
      className={`hover:bg-parlor-green relative flex h-full max-w-57.5 min-w-57.5 flex-col border-2 text-white ${selected ? 'border-light-green bg-parlor-green cursor-pointer' : productOutOfStock ? 'bg-parlor-green border-parlor-green-115' : 'bg-parlor-green-95 border-parlor-green-115 cursor-pointer'}`}
      tabIndex={0}
      disabled={productOutOfStock}
      data-cy={`interstitial-card-${card?.product?.handle}`}
      onClick={(e) => handleClick(e)}
    >
      <div className="relative">
        <div
          className={`${productOutOfStock ? 'bg-dawn-grey border-dawn-grey text-black' : 'bg-light-green border-parlor-green-60 text-parlor-green'} badge-text-r absolute top-3 left-3 rounded-full border px-2 py-0.5`}
        >
          {productOutOfStock ? 'Out of Stock' : discountAmount}
        </div>
        <Image
          src={card.image.url}
          alt={card.image.title}
          width={230}
          height={174}
          className="h-full object-cover"
        />
      </div>
      <div className="flex h-full flex-col justify-between p-3 text-left">
        <div>
          <div className="flex">
            <div className="h6 mb-2 flex-grow">{card.product.title}</div>
            <div className="min-h-6 min-w-6">
              <div className="h-6 w-6">
                {selected ? (
                  <SvgCheckbox />
                ) : productOutOfStock ? (
                  <SvgCrossedCheckbox />
                ) : (
                  <SvgEmptyCheckbox />
                )}
              </div>
            </div>
          </div>
          {card?.description && (
            <div className="body-xs mb-4">{card.description}</div>
          )}
        </div>
        {card?.details?.length > 0 &&
          card?.details.map((detail, index) => {
            return (
              <li key={index} className="body-xs mb-2 flex">
                <SvgCheck />
                <div className="ml-1">{detail.text}</div>
              </li>
            );
          })}
        <div className="mt-2">
          <Price
            price={card.variant.price.amount}
            compareAtPrice={card.variant.compareAtPrice.amount}
            priceClassOverride="price-r text-orange!"
            crossedPriceClassOverride="price-r-crossed text-dawn-grey-60!"
          />
        </div>
      </div>
    </button>
  );
}
